/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from 'react'
import { ILayout, useLayout } from '../../core'
import { useThemeMode } from '../../../partials'

const Footer = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  const theme = useThemeMode()
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <span className='text-gray-800 text-hover-primary'>
          Vampp - Score
        </span>
      </div>

      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1 gap-5'>
        <li className='menu-item'>
          <a href='https://github.com/eylulaydin7/VAMPP-score' rel='noreferrer' target='_blank'>
            <span className="ki-duotone ki-github" style={{
              fontSize:'2rem'
            }}
            ><span className="path1"></span><span className="path2"></span
            ></span>
          </a>
        </li>
        <li className='menu-item'>
          <img src={`/media/logos/vampp-logo-${theme.mode === 'dark' ? 'white' : 'dark'}.png`} alt='' className='h-20px' />
        </li>

      </ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export { Footer }
